import { render, staticRenderFns } from "./PresonalContact.vue?vue&type=template&id=a66fe5f8&scoped=true&"
import script from "./PresonalContact.vue?vue&type=script&lang=js&"
export * from "./PresonalContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66fe5f8",
  null
  
)

export default component.exports